module.exports = __webpack_public_path__ + "static/media/KW12_tvar.9a5d3071.JPG";